import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Tooltip } from '@material-ui/core';
import { isAfter } from 'date-fns';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import ResumoCheckList from '../PareceresAreaTecnica/ResumoCheckList';
import { dominioDemandaCirurgica, dominioNODE } from '../../config/database';
import 'assets/css/minha-agenda.css';
import 'primeicons/primeicons.css';

class AgendaAreaTecnica extends Component {
  state = {
    pedidos: [],
    pedido: [],
    abrePedido: false,
    abreResumo: false,
    abreModalparecer: false,
    nome_paciente: null,
    areaTecnicaId: null,
    ehAnestesia: false,
    centrosCirurgicosFiltrados: JSON.parse(localStorage.getItem('profissional')).centrosCirurgicos,
    profissional: JSON.parse(localStorage.getItem('profissional')),
    botoesCentroCirurgico: {},
    listaParecer: [],
    parecerSelecionado: null,
    motivoParecer: null,
    pedidoSelecionado: null,
    listaConvenios: [],
    conveniosSelecionados: null,
    idsConveniosSelecionados: [],
  };

  componentDidMount() {
    this.listarPedidosCirurgia(
      this.state.centrosCirurgicosFiltrados.join(),
      this.state.idsConveniosSelecionados.join()
    );
    this.renderBotoesCentroCirurgico();
    this.listarConvenios();
  }

  componentDidUpdate() {
    this.state.profissional.centrosCirurgicos.forEach(centroCirurgico => {
      const botao = document.getElementsByClassName(`fc-botao${centroCirurgico}-button`)[0];
      if (!botao) return;
      if (this.state.centrosCirurgicosFiltrados.includes(centroCirurgico)) botao.style = null;
      else {
        botao.style.backgroundColor = 'lightgray';
        botao.style.color = 'black';
      }
    });
  }

  listarConvenios = () => {
    dominioDemandaCirurgica.get('/api/convenio').then(response => {
      this.setState({ listaConvenios: response.data });
    });
  };

  listarPedidosCirurgia(centrosCirurgicosFiltrados, conveniosSelecionados) {
    const { areaTecnica_id } = JSON.parse(localStorage.getItem('profissional'));
    const { areaTecnicaAnestesia } = JSON.parse(localStorage.getItem('configuracoes'));

    this.setState({ areaTecnicaId: areaTecnica_id });

    let url = '';

    const ehAnestesia = areaTecnica_id === areaTecnicaAnestesia;
    this.setState({ ehAnestesia });

    if (ehAnestesia)
      url = `/api/minhaAgendaAnestesia/${centrosCirurgicosFiltrados}/${conveniosSelecionados?.length === 0 ? '0' : conveniosSelecionados
        }`;
    else
      url = `/api/minhaAgenda/${areaTecnica_id}/${centrosCirurgicosFiltrados}/${conveniosSelecionados?.length === 0 ? '0' : conveniosSelecionados
        }`;

    dominioDemandaCirurgica.get(url).then(response => {
      this.setState({
        pedidos: response.data.map(pedido => {
          return {
            id: pedido.id,
            title: pedido.codigo,
            start: pedido.dataHoraSugerida,
            cor: pedido.cor,
            corBolinha: pedido.corbolinha,
            pedido,
          };
        }),
      });
    });
  }

  handleEventClick = info => {
    const { areaTecnica_id } = JSON.parse(localStorage.getItem('profissional'));

    this.setState({ areaTecnicaId: areaTecnica_id });

    let url = '';

    if (this.state.ehAnestesia)
      url = `/api/motivoAvaliacaoPreAnestesicaMinhaAgenda/${info.event.id}`;
    else url = `/api/itensMinhaAgenda/${areaTecnica_id}/${info.event.id}`;

    dominioDemandaCirurgica.get(url).then(res => {
      this.setState({
        pedido: res.data,
        abrePedido: true,
        nome_paciente: res.data[0].nome,
        pedidoSelecionado: info.event._def.extendedProps.pedido,
      });
    });
  };

  handleImpressaoMateriais = async data => {
    await dominioDemandaCirurgica().then(promise => {
      window.open(
        `${promise.config.baseURL}/impressoMateriais/${data}/${this.state.areaTecnicaId
        }/${this.state.centrosCirurgicosFiltrados.join()}`
      );
    });
  };

  handleImpressaoAnestesia = async data => {
    await dominioDemandaCirurgica().then(promise => {
      window.open(
        `${promise.config.baseURL
        }/impressoAnestesia/${data}/${this.state.centrosCirurgicosFiltrados.join()}`
      );
    });
  };

  renderBotaoImpressaoMateriais = data => {
    const botao = document.createElement('button');
    botao.classList.add('botao-impressao-materiais');

    const icone = document.createElement('i');
    icone.classList.add('pi');
    icone.classList.add('pi-print');

    botao.appendChild(icone);
    botao.onclick = () => this.handleImpressaoMateriais(data);

    return botao;
  };

  renderBotaoImpressaoAnestesia = data => {
    const botao = document.createElement('button');
    botao.classList.add('botao-impressao-anestesia');

    const icone = document.createElement('i');
    icone.classList.add('pi');
    icone.classList.add('pi-print');

    botao.appendChild(icone);
    botao.onclick = () => this.handleImpressaoAnestesia(data);

    return botao;
  };

  renderDivBotoesTipoMes = dataEvento => {
    const data = new Date(dataEvento);
    const dataFormat = data
      .toLocaleDateString()
      .split('/')
      .reverse()
      .join('-');
    //  Identificando o node específico pelo atributo 'data-date'
    const cellDoDia = document.querySelector(`td[data-date="${dataFormat}"]`);

    if (cellDoDia) {
      //  Essa é a div que iremos colocar o(s) botão(ões)
      const divDoDia = cellDoDia.querySelector('.fc-daygrid-day-top');

      //  Verificar se a div já foi incluída
      const divBotoesExistente = divDoDia.getElementsByClassName(`divBotao-${dataFormat}`);
      if (divBotoesExistente.length > 0) return;

      //  Div dos botões e botão
      const divBotoes = document.createElement('div');
      divBotoes.classList.add(`divBotao-${dataFormat}`);
      divBotoes.classList.add(`div-botao-impressao`);
      let botaoImpressao = null;
      if (!this.state.ehAnestesia) botaoImpressao = this.renderBotaoImpressaoMateriais(dataFormat);
      else botaoImpressao = this.renderBotaoImpressaoAnestesia(dataFormat);
      divBotoes.appendChild(botaoImpressao);

      //  Pegando o link do número do dia pq tenho que inserir o botão antes
      //  const linkDia = cellDoDia.querySelector('.fc-daygrid-day-number');

      divDoDia.appendChild(divBotoes);
    }
  };

  insertDivBotao = arg => {
    const dataInicio = new Date(arg.event.start);
    const tipo = arg.view.type;

    if (tipo === 'dayGridMonth') return this.renderDivBotoesTipoMes(dataInicio);
  };

  eventContent = arg => {
    //  Divs internas para fazer as divisões
    const divCentral = document.createElement('div');
    const divEsquerda = document.createElement('div');
    const divDireita = document.createElement('div');

    //  Cor do status
    divCentral.style.backgroundColor = arg.event._def.extendedProps.cor;
    divCentral.style.color = 'white';

    //  Atribuindo as classes
    divCentral.classList.add('div-central-evento');
    divEsquerda.classList.add('div-esquerda-evento');
    divDireita.classList.add('div-direita-evento');

    divCentral.appendChild(divEsquerda);
    divCentral.appendChild(divDireita);

    //  codigo
    const codigoPedido = document.createElement('span');
    codigoPedido.innerText = arg.event._def.title;
    divEsquerda.appendChild(codigoPedido);

    //  colocando a bolinha
    const bolinha = document.createElement('span');
    bolinha.classList.add('bolinha');
    bolinha.style.backgroundColor = arg.event._def.extendedProps.corBolinha ?? 'lightgray';
    divDireita.appendChild(bolinha);

    const arrayDeDomNodes = [divCentral];
    return { domNodes: arrayDeDomNodes };
  };

  getCorpoItensAreaTecnica = () => {
    return (
      <div>
        <h3>{`Paciente: ${this.state.nome_paciente}`}</h3>
        {this.state.pedido.length > 0 ? (
          this.state.pedido.map((ped, index) => {
            return (
              <p key={ped.id}>
                <strong>{`${index + 1}: `}</strong>
                {`${ped.descricao}  `}
                <p>
                  <strong>{`Quantidade: ${ped.quantidade} ${ped.unidademedidadesc ?? ''}`}</strong>
                </p>
              </p>
            );
          })
        ) : (
          <span>Sem itens.</span>
        )}
        {this.state.pedidoSelecionado?.descricaomotivocancelamento ? (
          <>
            <hr />
            <div>
              <h5 className="titulo-vermelho">Pedido cancelado</h5>
              <div>
                <span>
                  <strong>Motivo: </strong>
                  {this.state.pedidoSelecionado.descricaomotivocancelamento}
                </span>
              </div>
              <div>
                <span>
                  <strong>Observações: </strong>
                  {this.state.pedidoSelecionado.observacoescancelamento}
                </span>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  };

  getCorpoAnestesia = () => {
    const anestesiaProposta = this.state.pedido[0]?.tipoanestesia
      ? this.state.pedido[0]?.tipoanestesia
      : 'Não informado.';
    const motivoAvaliacaoAnestesica = this.state.pedido[0]?.motivoAvaliacaoAnestesica
      ? this.state.pedido[0]?.motivoAvaliacaoAnestesica
      : 'Não informado.';

    return (
      <div>
        <h3>{`Paciente: ${this.state.nome_paciente}`}</h3>
        <p>
          <strong>{`Anestesia Proposta: `}</strong>
          {`${anestesiaProposta}`}
        </p>
        <p>
          <strong>{`Motivo de Avaliação Pré Anestésica: `}</strong>
          {`${motivoAvaliacaoAnestesica}`}
        </p>
        {this.state.pedidoSelecionado.descricaomotivocancelamento ? (
          <>
            <hr />
            <div>
              <h5 className="titulo-vermelho">Pedido cancelado</h5>
              <div>
                <span>
                  <strong>Motivo: </strong>
                  {this.state.pedidoSelecionado.descricaomotivocancelamento}
                </span>
              </div>
              <div>
                <span>
                  <strong>Observações: </strong>
                  {this.state.pedidoSelecionado.observacoescancelamento}
                </span>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  };

  removerBotoesImpressao = () => {
    document.querySelectorAll('.div-botao-impressao').forEach(e => e.remove());
  };

  handleClickBotaoCentroCirurgico = centroCirurgico_id => {
    let { centrosCirurgicosFiltrados } = this.state;
    if (centrosCirurgicosFiltrados.includes(centroCirurgico_id)) {
      if (centrosCirurgicosFiltrados.length === 1) return;
      centrosCirurgicosFiltrados = centrosCirurgicosFiltrados.filter(
        id => id !== centroCirurgico_id
      );
    } else {
      centrosCirurgicosFiltrados.push(centroCirurgico_id);
    }
    this.removerBotoesImpressao();

    this.setState({ centrosCirurgicosFiltrados });
    this.listarPedidosCirurgia(
      centrosCirurgicosFiltrados.join(),
      this.state.idsConveniosSelecionados.join()
    );
  };

  renderBotoesCentroCirurgico = () => {
    if (this.state.profissional.centrosCirurgicos.length <= 1) {
      this.setState({
        botoesCentroCirurgico: null,
      });
      return;
    }

    const botoes = {};

    dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
      response.data.forEach(centroCirurgico => {
        if (this.state.profissional.centrosCirurgicos.includes(centroCirurgico.id))
          botoes[`botao${centroCirurgico.id}`] = {
            text: centroCirurgico.departamento,
            click: () => {
              this.handleClickBotaoCentroCirurgico(centroCirurgico.id);
            },
          };
      });

      this.setState({
        botoesCentroCirurgico: botoes,
      });
    });
  };

  handleGravarParecer() {
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

    if (
      this.state.parecerSelecionado.id === configuracoes.parecerRejeicao ||
      this.state.parecerSelecionado.id === configuracoes.parecerPendente
    ) {
      if (this.state.motivoParecer === null || this.state.motivoParecer === '') {
        alert('Para rejeição ou pendência o parecer é obrigatório');
        return;
      }
    }

    const dadosParecer = {
      justificativa: this.state.motivoParecer ?? '-',
      areaTecnica: profissional.areaTecnica_id,
      pedidoCirurgia: this.state.pedidoSelecionado.id,
      parecerTecnico: this.state.parecerSelecionado.id,
    };

    dominioDemandaCirurgica
      .post('/api/parecerAreaTecnica', dadosParecer)
      .then(() => {
        this.setState({
          abreModalparecer: false,
        });
        this.listarPedidosCirurgia(
          this.state.centrosCirurgicosFiltrados.join(),
          this.state.idsConveniosSelecionados.join()
        );
      })
      .then(() => {
        const dataLog = {
          id_usuario: profissional.userid,
          username: profissional.username,
          id_pedido: this.state.pedidoSelecionado.id,
          tipo: 'Parecer',
          descricao: `(${this.state.parecerSelecionado.descricao}) - ${this.state.motivoParecer}`,
        };
        dominioNODE.post('/logpedido', dataLog).catch(error => {
          console.log(`ERRO AO INCLUIR LOG: ${error}`);
        });
      });
  }

  renderHeaderDialogPedido = () => {
    return (
      <div className="div-header-dialog-pedido">
        <div>
          Pedido selecionado:
          <Link onClick={() => this.setState({ abreResumo: true })}>
            {` ${this.state.pedidoSelecionado?.codigo}`}
          </Link>
        </div>
        <div>
          <Tooltip
            title={
              <>
                <h5>{this.state.pedidoSelecionado?.descricaoparecer}</h5>
                <p style={{ wordWrap: 'break-word' }}>
                  {this.state.pedidoSelecionado?.justificativaparecer}
                </p>
              </>
            }
          >
            <Link
              onClick={() => {
                const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));
                const today = new Date();
                today.setHours(0);
                today.setMinutes(0);
                today.setSeconds(0);
                if (
                  isAfter(new Date(), new Date(this.state.pedidoSelecionado.dataHoraSugerida)) ||
                  this.state.pedidoSelecionado.idstatus === configuracoes.statusCancelado
                )
                  return;

                this.setState({
                  abreModalparecer: true,
                });
              }}
            >
              Parecer
            </Link>
          </Tooltip>
        </div>
      </div>
    );
  };

  carregarListaParecer = () => {
    dominioDemandaCirurgica.get(`/api/parecerTecnicoCheckList`).then(res => {
      this.setState({
        listaParecer: res.data,
      });
    });
  };

  render() {
    return (
      <div id="naruto">
        <DialogPrime
          header={this.renderHeaderDialogPedido()}
          visible={this.state.abrePedido}
          style={{ width: '65vw' }}
          onHide={() =>
            this.setState({
              abrePedido: false,
              parecerSelecionado: null,
              motivoParecer: null,
            })
          }
        >
          {this.state.ehAnestesia ? this.getCorpoAnestesia() : this.getCorpoItensAreaTecnica()}
        </DialogPrime>
        <DialogPrime
          visible={this.state.abreResumo}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreResumo: false })}
        >
          <ResumoCheckList id={this.state.pedidoSelecionado?.id} />
        </DialogPrime>
        <DialogPrime
          header={`Pedido nº  ${this.state.pedidoSelecionado?.codigo}`}
          visible={this.state.abreModalparecer}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreModalparecer: false })}
          onShow={() => this.carregarListaParecer()}
        >
          <h4>{this.state.nome_paciente}</h4>
          <Autocomplete
            id="filtroPrioridade"
            options={this.state.listaParecer}
            style={{ marginBottom: '20px', marginTop: '10px' }}
            getOptionLabel={option => `${option.descricao ?? ''}`}
            onChange={(e, value) => {
              this.setState({ parecerSelecionado: value });
            }}
            value={this.state.parecerSelecionado}
            filterSelectedOptions
            renderInput={params => (
              <TextField {...params} label="Selecione o parecer" variant="outlined" />
            )}
          />

          <div>
            <TextField
              id="descricaoParecer"
              multiline
              onChange={e => {
                this.setState({ motivoParecer: e.target.value });
              }}
              style={{ marginBottom: '20px', marginTop: '10px', textAlign: 'left' }}
              inputProps={{ maxLength: '300' }}
              label="Descreva o parecer"
              variant="outlined"
              fullWidth
              rows={3}
            />
            <div style={{ float: 'right' }}>
              <Button
                style={{ marginBottom: '15px' }}
                variant="contained"
                color="secondary"
                onClick={() => this.handleGravarParecer()}
              >
                Confirmar
              </Button>
              <br />
            </div>
          </div>
        </DialogPrime>
        <GridContainer justify="center" id="agenda">
          <GridItem xs={12} sm={12} md={11}>
            <div className="div-botoes-filtros">
              <div className="div-selecao-convenios-filtro-agenda">
                <MultiSelect
                  value={this.state.conveniosSelecionados}
                  options={this.state.listaConvenios}
                  optionLabel="descricao"
                  placeholder="Selecione um convênio"
                  maxSelectedLabels={4}
                  onChange={e => {
                    this.setState({ conveniosSelecionados: e.value }, () => {
                      const { conveniosSelecionados } = this.state;
                      if (conveniosSelecionados && conveniosSelecionados.length > 0) {
                        this.setState(
                          {
                            idsConveniosSelecionados: conveniosSelecionados.map(
                              convenio => convenio.id
                            ),
                          },
                          () => {
                            this.removerBotoesImpressao();
                            this.listarPedidosCirurgia(
                              this.state.centrosCirurgicosFiltrados.join(),
                              this.state.idsConveniosSelecionados.join()
                            );
                          }
                        );
                      } else {
                        this.setState({ idsConveniosSelecionados: [] }, () => {
                          this.removerBotoesImpressao();
                          this.listarPedidosCirurgia(
                            this.state.centrosCirurgicosFiltrados.join(),
                            this.state.idsConveniosSelecionados.join()
                          );
                        });
                      }
                    });
                  }}
                />
              </div>
            </div>
            <FullCalendar
              //  https://fullcalendar.io/docs
              plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
              initialView="dayGridMonth"
              locale="pt-br"
              navLinks
              editable
              dayMaxEvents
              customButtons={this.state.botoesCentroCirurgico}
              buttonText={{
                day: 'Dia',
                month: 'Mês',
                next: '>',
                nextYear: 'Próximo ano',
                prev: '<',
                prevYear: 'Ano anterior',
                today: 'Hoje',
                week: 'Semana',
              }}
              headerToolbar={{
                left: `prev,next,today${this.state.botoesCentroCirurgico
                    ? ` ${Object.keys(this.state.botoesCentroCirurgico).join()}`
                    : ''
                  }`,
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay',
              }}
              //  https://fullcalendar.io/docs/event-parsing
              eventDidMount={this.insertDivBotao}
              events={this.state.pedidos}
              eventClick={this.handleEventClick}
              eventContent={this.eventContent}
              moreLinkText="pedidos"
              dragScroll
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}
export default AgendaAreaTecnica;
